import { useState } from "react";
import { Box, IconButton, Popover, useMediaQuery, useTheme } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import PatientSearchBar from "./PatientSearchBar";

interface Props {
  variant?: "internal" | "external";
}

/**
 * Header placement for the patient search: a centered inline bar on sm+, and on xs a search icon
 * that opens the bar in a popover (so it doesn't crowd the mobile toolbar).
 */
export default function HeaderPatientSearch({ variant = "internal" }: Props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  if (!isMobile) {
    return (
      <Box sx={{ flex: 1, display: "flex", justifyContent: "center", px: 2 }}>
        <PatientSearchBar variant={variant} />
      </Box>
    );
  }

  return (
    <>
      <IconButton
        color="inherit"
        aria-label="search patients"
        onClick={(e) => setAnchor(e.currentTarget)}
      >
        <SearchIcon />
      </IconButton>
      <Popover
        open={!!anchor}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{ paper: { sx: { p: 1.5, width: "min(90vw, 340px)" } } }}
      >
        <PatientSearchBar
          variant={variant}
          onDark={false}
          focusOnMount
          onSelect={() => setAnchor(null)}
        />
      </Popover>
    </>
  );
}
